import Cookies from 'js-cookie';
import { cookies, storageKeys } from 'static';
import { clearAnalyticsFarmContext, clearAnalyticsUser } from 'analytics/ga4';

const SHARED_COOKIE_DOMAIN = '.farmersplan.com';

const AUTH_COOKIE_NAMES = [
  'token',
  cookies.CropsSelectedAccount,
  cookies.CropsRoleId,
  cookies.FarmIdCookie,
] as const;

function expireCookie(name: string, options: { path: string; domain?: string }) {
  Cookies.remove(name, options);
  for (const secure of [true, false]) {
    let cleared = `${encodeURIComponent(name)}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${options.path}`;
    if (options.domain) {
      cleared += `;domain=${options.domain}`;
    }
    if (secure) {
      cleared += ';Secure';
    }
    cleared += ';SameSite=Lax';
    document.cookie = cleared;
  }
}

export function clearAuthCookies() {
  for (const name of AUTH_COOKIE_NAMES) {
    expireCookie(name, { path: '/', domain: SHARED_COOKIE_DOMAIN });
    if (name === 'token') {
      expireCookie(name, { path: '/' });
    }
  }
}

export function clearAuthStorage() {
  localStorage.removeItem(cookies.FarmersPlanToken);
  localStorage.removeItem('token');
  sessionStorage.removeItem(storageKeys.FarmOnboardingRegistrationDate);
  sessionStorage.removeItem(storageKeys.FarmOnboardingRegistrationFarmId);
  sessionStorage.removeItem(storageKeys.RecentFarmId);
  sessionStorage.removeItem(storageKeys.RecentFarmName);
  sessionStorage.removeItem(storageKeys.RecentFarmOrgNumber);
  sessionStorage.removeItem(storageKeys.FarmOnboardingCelebrationPending);
  sessionStorage.removeItem(storageKeys.FarmOnboardingCelebrationFarmId);
}

export function clearAuthSession() {
  clearAuthStorage();
  clearAuthCookies();
  clearAnalyticsFarmContext();
  clearAnalyticsUser();
}
